module.exports = __webpack_public_path__ + "img/indicadores-gestion.85028774.svg";